import { motion } from "framer-motion";
import { Car, BatteryCharging, Sparkles, Bike } from "lucide-react";
import { useLang } from "../i18n";

export const About = () => {
  const { t } = useLang();
  const features = [
    { icon: Car, title: t.about.f1Title, body: t.about.f1Body },
    { icon: BatteryCharging, title: t.about.f2Title, body: t.about.f2Body },
    { icon: Sparkles, title: t.about.f3Title, body: t.about.f3Body },
    { icon: Bike, title: t.about.f4Title, body: t.about.f4Body },
  ];

  return (
    <section id="services" className="relative py-28 md:py-36 bg-[var(--c-bg-2)]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[var(--c-gold)]" />
              <span className="overline">{t.about.tag}</span>
            </div>
            <h2 className="font-display text-5xl sm:text-6xl font-semibold leading-[0.95] text-white">
              {t.about.title}
            </h2>
            <p className="mt-7 text-neutral-400 text-lg leading-relaxed max-w-lg">{t.about.body}</p>
          </motion.div>

          <div className="grid sm:grid-cols-2 gap-5">
            {features.map((f, i) => (
              <motion.div
                key={i}
                data-testid={`feature-card-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className="hover-lift rounded-2xl p-7 bg-[var(--c-bg-3)] gold-border"
              >
                <div className="w-12 h-12 rounded-xl bg-[var(--c-gold)]/10 flex items-center justify-center mb-5">
                  <f.icon size={22} className="text-[var(--c-gold)]" />
                </div>
                <h3 className="font-display text-2xl text-white mb-2">{f.title}</h3>
                <p className="text-sm text-neutral-400 leading-relaxed">{f.body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
